export default {
  login: '/auth/login',
  register: '/auth/register',
  profile: '/profile',
  subscriber: '/subscriber',
  checkAuthCode: '/auth/check-auth-code',
  forgotPassword: '/auth/forgot-password',
  changePassword: '/auth/change-password',
  confirmInvite: '/auth/confirm-invite',
  checkCode: '/users/check-code',
  checkPhoneCode: '/auth/check-phone-code',
  currentUser: '/auth/current',
  logout: '/auth/logout',
  isTeam: '/auth/is-team',
  createInvite: '/users/create-invite',
  languages: '/languages',
  menus: '/menus',
  upload: '/temp-files/upload',
  deleteTempFile: '/temp-files/delete',
  socialLogin: '/social-login',
  feedbacks: '/feedback',
  comments: '/comments',
  tickets: '/tickets',
  slash: '/',
  messages: '/messages',
  blogPost: '/blog-post',
  blogPostCategories: '/blog-post-categories',
  emotions: '/emotions',
  kbPost: '/kb-post',
  kbPostCategory: '/kb-post-category',
  pages: '/pages',
  files: '/files',
  vote: '/vote',
  modules: '/modules',
  subscriberModules: '/subscriberModules',
  customLink: '/custom-link',
  documents: '/documents',
  gifs: '/gifs',
  channels: '/channels',
  users: '/users',
  // intercom: '/intercom',
  youtube: '/youtube',
  unsplash: '/unsplash',
  gallery: '/gallery',
};



// WEBPACK FOOTER //
// ./src/services/api.routes.js